import React from "react";

import { Row, Col } from "antd";
import PropTypes from "prop-types";

import Spacer from "shared/components/Spacer";
import Tile from "shared/components/Tile";
import {
  VerificationStatus,
  NoVerificationsPlaceholder,
  IdVerificationDetails,
} from "shared/components/Verification";
import { isPersonaIncomplete } from "shared/utils/persona";

import { verificationPropType } from "shared/utils/propTypes";

const IdVerification = ({ verification, personaStatus }) => {
  // PROD-734: If persona is incomplete, show pending state instead of stale verification data
  const isIncomplete = isPersonaIncomplete(personaStatus);

  if (isIncomplete) {
    return (
      <Tile noBorder>
        <Tile.Inner>
          <Row gutter={[16, 16]} type="flex">
            <Col span={24}>
              <VerificationStatus
                type={verification?.verificationType}
                status="pending"
                verificationDate={null}
              />
            </Col>
          </Row>
        </Tile.Inner>
      </Tile>
    );
  }

  return (
    <>
      {!verification && (
        <NoVerificationsPlaceholder message="ID verification not available" />
      )}
      {verification && (
        <Tile noBorder>
          <Tile.Inner>
            <Row gutter={[16, 16]} type="flex">
              <Col span={24}>
                <VerificationStatus
                  type={verification.verificationType}
                  status={verification.status}
                  verificationDate={verification.verificationDate}
                />
              </Col>
            </Row>
            <Spacer />
            <IdVerificationDetails verification={verification} inset />
          </Tile.Inner>
        </Tile>
      )}
    </>
  );
};

IdVerification.propTypes = {
  verification: verificationPropType,
  personaStatus: PropTypes.string,
};

IdVerification.defaultProps = {
  verification: undefined,
  personaStatus: undefined,
};

export default IdVerification;
